<template>
  <div>
    <iframe frameborder="0" scrolling="no" width="100%" height="60px" src="https://dwlm.12371.cn/daohang/index.shtml"></iframe>
    <div>
      <div id="lm_header" style="background: #f6b84b; width: 100%;">
        <div style="width: 1000px; height: 60px; margin: 0 auto;">
            <h1 style="float: left; margin: 8px 0px 0px 0px;">
                <img src="/static/images/ahdwlm.jpg" border="0"></h1>
            <p style="float: right; margin: 35px 10px 0px 0px;">
                <a href="http://dwlm.12371.cn" style="text-decoration:none; color:#000;">返回联盟首页</a>&nbsp;<span style="color: #1e6ead;">|</span>&nbsp;<a href="http://www.12371.cn/" style="text-decoration:none; color:#000;">共产党员网</a></p>
          </div>
      </div>

      
      <div id="_Node" style="height: 40px;position:relative;">
        <div class="lmtop2" style="height: 40px;position:relative;">
            <div class="wd960">
                <div style="padding-top:5px;" class="style1"><a href="javascript:;">当前位置：</a> <a href="http://dwlm.12371.cn/">全国党建网站联盟&gt;</a>  <a href="http://www.ahxf.gov.cn">安徽省&gt;</a>  <a href="http://www.aqxf.gov.cn/">
					安庆市&gt; </a><a href="/">潜山市</a></div>
                <!--<h1 class="style1">|潜山市</h1>-->
            </div>
        </div>
        <div class="lmtop3" style="display:none;">
          <div class="wd960">
              <ul>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qsmcxfw" target="_blank">梅城镇</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qsstzsxfw" target="_blank">天柱山镇</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qsshxfw" target="_blank">水吼镇</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qswmxfw" target="_blank">五庙乡</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qsybxfw" target="_blank">油坝乡</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qswhxfw" target="_blank">王河镇</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qshnxfw" target="_blank">黄泥镇</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/index/qsxhpjlcxfw" target="_blank">黄铺镇</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qsdmxfw" target="_blank">痘姆乡</a></li>
              <!--<li><a href="http://newwcwy.ahxf.gov.cn/Skin2/Index/qssyjxfw" target="_blank">余井镇</a></li>-->
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qssyjxfw" target="_blank">余井镇</a></li>
              <!--<li><a href="http://newwcwy.ahxf.gov.cn/Skin3/Index/qsxltxfw" target="_blank">龙潭乡</a></li>-->
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qsxltxfw" target="_blank">龙潭乡</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/aqqsxytzxfw" target="_blank">源潭镇</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qsxcsxfw" target="_blank">槎水镇</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qsshbxfw" target="_blank">黄柏镇</a></li>
              <!--<li><a href="http://newwcwy.ahxf.gov.cn/Skin3/Index/qsgzxfw" target="_blank">官庄镇</a></li>-->
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qsgzxfw" target="_blank">官庄镇</a></li>
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin4/Index/qstfxfw" target="_blank">塔畈乡</a></li>		
              <li><a href="http://newwcwy.ahxf.gov.cn/Skin2/Index/qskfqxfw" target="_blank">开发区</a></li>	
              </ul>		
            </div>
        </div>
      </div>

        <div class="top-bg">
          <div class="w1100 top">
            <div class="floatL">
                <div class="floatL" style="width:124px;">欢迎访问潜山先锋网!</div>
                <div class="floatL" style="background:url(../assets/css/top_pic.jpg) left center no-repeat; padding-left:23px; width:170px;">
                {{this.todayTime}}
                </div>
                <div class="floatL" style="background:url(../assets/css/top_pic2.jpg) left center no-repeat; padding-left:40px;">天气预报：
                </div>
                <div class="floatL" style="position: relative;">
                <iframe width="300px" scrolling="no" height="32px" style="position: absolute;top:0px;" frameborder="0" allowtransparency="true" src="https://i.tianqi.com/?c=code&a=getcode&id=34&icon=1&py=qianshan"></iframe>
                </div>   
            </div>
            <div class="floatR">
              <div class="sy">
                  <ul>
                      <li><a href="javascript:;" onclick="this.style.behavior='url(#default#homepage)';setHomePage('http://qs.ahxf.gov.cn/');">设为首页</a></li>
                      <li><a href="javascript:;" onclick="bookmark('潜山先锋网','http://qs.ahxf.gov.cn/');">加入收藏</a></li>
                      
                      <li><a href="http://qs.web.ahxf.gov.cn" title="返回旧版" target="_blank">返回旧版</a></li>
                      <div class="clear"></div>
                  </ul>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>


        <div class="w1100">
            <div class="floatL" style="height:84px; padding-top:25px;"><img src="/static/images/logo/xf_pic.png"></div>
            <div class="floatR" style="padding-top:43px;">
                <div class="floatL marginR10" style="width:180px;">
                  <el-input v-model="searchKey" placeholder="请输入搜索关键字" size="mini"></el-input>
                </div>
                <div class="floatL">
                  <el-button type="warning" size="mini" @click="search()">搜索</el-button>
                  <!-- <el-button type="warning" size="mini">电子政务</el-button> -->
                </div>
                <div class="clear"></div>
            </div>
            <div class="clear"></div>
        </div>

        <div class="w1100" style="background:url(/static/images/red_row.jpg) top repeat-x; height:57px; padding:10px 0; border-bottom:1px solid #E0E0E0; font-weight:bold;">
        <div class="floatL nav"><a href="/" title="首页" target="_self">首页</a></div>
        <div class="floatL nav">
            <div><a href="/qsxf-web/module/index?code=6144" title="魅力潜山" target="_self">魅力潜山</a></div>            
        </div>
        <div class="floatL nav">
        	<div><a href="/qsxf-web/module/list?code=6145" title="时政资讯" target="_self">时政资讯</a></div>    
        </div>
        <div class="floatL nav">
         	<div><a href="/qsxf-web/module/list?code=6146" title="潜阳要闻" target="_self">潜阳要闻</a></div>          
        </div>
        <div class="floatL nav">
        	<div><a href="/qsxf-web/module/list?code=6177" title="人事任免" target="_self">人事任免</a></div>          
        </div>
		    <div class="floatL nav">
        	<div><a href="/qsxf-web/module/index?code=6149" title="干部人才" target="_self">干部人才</a></div>   
        </div>
		 <div class="floatL nav">           
        <div><a href="/qsxf-web/module/index?code=6151" title="党建园地" target="_self">党建园地</a></div>
        </div>
        <div class="floatL nav" style="display:none;">           
            <div><a href="/qsxf-web/module/index?code=7100" title="教育课件" target="_self">教育课件</a></div>
        </div>
        <div class="floatL nav" style="display:none;">
            <div><a href="/qsxf-web/module/index?code=7200" title="党建栏目" target="_self">党建栏目</a></div>
        </div>
        <div class="floatL nav" style="background:none;">
            <div><a href="/qsxf-web/module/index?code=6253" title="党务指南" target="_self">党务指南</a></div>
        </div> 
      </div>
    </div>
  </div>
</template>


<script>

import  '../assets/css/css.css'

export default {
  name: 'HeaderIndex',
  data () {
    return {
      todayTime: "",
      searchKey:""
    }
  },
  mounted() {
     if (this.checkIE()) {
      window.addEventListener('hashchange', () => {
        let currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
    this.initTime();
      window['setHomePage'] = (url) => {
        this.setHomePage(url);
     };
      window['bookmark'] = (url) => {
        this.bookmark(url);
     }
  },
  methods: {
      checkIE:function(){
        return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;
      },
      search:function(){
        // this.$router.push({path:'/search',query:{key:this.searchKey}});
        window.location.href = '/qsxf-web/search?key='+this.searchKey;
      },
      setHomePage:function(url){
        if (document.all) {
            document.body.style.behavior='url(http://qs.ahxf.gov.cn/)';
            document.body.setHomePage(url);
        }else{
            alert("您好,您的浏览器不支持自动设置页面为首页功能,请您手动在浏览器里设置该页面为首页!");
        }
      },
      bookmark:function(title, url){
          if(document.all) { // ie
              window.external.AddFavorite(url, title);
          }else if(window.sidebar) { // firefox
              window.sidebar.addPanel(title, url, "");
          }else if(window.opera && window.print) { // opera
              var elem = document.createElement('a');
              elem.setAttribute('href',url);
              elem.setAttribute('title',title);
              elem.setAttribute('rel','sidebar');
              elem.click(); // this.title=document.title;
          }else{
              alert("加入收藏失败，请使用Ctrl+D进行添加");
          }
      },
      initTime:function(){
            var str = "";
            var tmpDate = new Date();
            var date = tmpDate.getDate();
            var month= tmpDate.getMonth() + 1 ;
            var year= tmpDate.getFullYear();
            str += year;
            str += "年";
            str += month;
            str += "月";
            str += date;
            str += "日";
            str += "  ";
            var now = new Date() //定义新对象，new具有Date的性质
            if (now.getDay() == 5) str +=("星期五")
            if (now.getDay() == 6) str +=("星期六")
            if (now.getDay() == 0) str +=("星期日")
            if (now.getDay() == 1) str +=("星期一")
            if (now.getDay() == 2) str +=("星期二")
            if (now.getDay() == 3) str +=("星期三")
            if (now.getDay() == 4) str +=("星期四");
            this.todayTime = str;
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.searchform{background:url(/static/images/search_l.jpg); border:0; height:25px; width:153px; padding:0 22px 0 5px;}


.wd960{width:960px; position:relative; margin:0 auto;font:14px "微软雅黑","宋体"; }
.clear{ clear:both;}
.wd960 a{ font-family:"微软雅黑","宋体"; font-size:14px;text-decoration: none; font-style:normal; letter-spacing:normal; color:#003c78;}
.wd960 A:hover {COLOR: #4e667b; TEXT-DECORATION: underline} 
.wd960 A:active {TEXT-DECORATION: none}
 
.lmtop2{width:100%;height:80px; background:#f3f3f3;position: relative;}
.lmtop2 p{line-height:50px;}
.lmtop2 h1{font-size:22px; color:#082e6c; margin-top:5px;}
.lmtop2 h1 span{font-size:14px; color:#666666; font-weight:normal;}
 
.lmtop3{width:100%; height:auto; background:#fff; float:left ;border-bottom:0px solid #07357f;position: relative; padding:5px 0px;}
.lmtop3 ul { margin:0px; padding:0px;}
.lmtop3 ul li{width:90px;height:25px;line-height:25px; float:left; padding-right: 10px; text-align:center; }
.lmtop3 ul li a{font-weight: bold;color: #333;font-size: 16px;}
.lmtop3 ul li a:hover{ color:#c00;TEXT-DECORATION: none}
.lmtop3 ul li a span{font-size:12px; font-weight:normal; color:#666666;}
 
.up,.down{overflow:hidden; display:block;}
#down{display:none;}
.updown{display:block;width:70px;height:41px;position:absolute;top:160px;right:250px;z-index:9999;}
.updown a{ font-family:"微软雅黑","宋体"; font-size:14px;text-decoration: none; font-style:normal; letter-spacing:normal; color:#003c78;}
.updown A:hover {COLOR: #4e667b; TEXT-DECORATION: underline} 
.updown A:active {TEXT-DECORATION: none}
.style1 {
	text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/HeaderIndex.vue